// AI 계약 상담 (alfred, NZSC-3151/3153) API URL 상수.
// 백엔드 엔진은 cold-syrup. 프론트는 api-public BFF(`/api/v1/alfred/*`)를 경유한다.
// 기존 리포트/컨시어지 호출과 동일하게 userNo 는 Bearer 토큰에서 BFF 가 서버측에서 추출하므로
// 프론트에서 userNo 를 직접 전송하지 않는다. (토큰이 암호화되어 있어 프론트 디코딩 불가)
export default {
  // 세션
  POST_SESSION: "/api/v1/alfred/session", // 세션 생성
  GET_SESSION_LIST: "/api/v1/alfred/session", // 세션 목록 (limit/offset)
  GET_SESSION_DETAIL: "/api/v1/alfred/session", // + `/${sessionSeq}` 세션 + 메시지
  DELETE_SESSION: "/api/v1/alfred/session", // + `/${sessionSeq}`
  POST_SESSION_BIND: "/api/v1/alfred/session", // + `/${sessionSeq}/bind`

  // 메시지
  POST_MESSAGE: "/api/v1/alfred/message", // 멀티턴 전송
  POST_MESSAGE_RATING: "/api/v1/alfred/message", // + `/${messageSeq}/rating`

  // 계약서 업로드 (PDF 정본만 accepted)
  POST_CONTRACT: "/api/v1/alfred/contract",

  // 지갑(KRW 잔액): { userNo, balance, totalCharged, totalUsed }
  GET_WALLET: "/api/v1/alfred/wallet",

  // 충전 주문 생성 (PG 결제 → 백엔드 웹훅 확정)
  POST_ORDER: "/api/v1/alfred/order",
  // 페이플(카드) PC 결제 확정 — 서버 cPay 검증 후 grant (카카오는 포트원 웹훅이 처리)
  POST_ORDER_PAYPLE_COMPLETE: "/api/v1/alfred/order/payple-complete",
  // 카카오(포트원) 동기 결제 확정 — 서버가 PortOne getPayment 로 PAID 검증 후 grant(멱등).
  // 웹훅이 SSOT 이나 웹훅 라우팅 의존을 피하려 결제 직후에도 호출(이중 안전).
  POST_ORDER_COMPLETE: "/api/v1/alfred/order/complete",
};
